package com.essntl.features.invoice.data.repository

import com.essntl.core.supabase.*
import com.essntl.core.utils.repository.Repository
import com.essntl.features.invoice.data.supabase.InvoiceSupabaseDataSource
import com.essntl.features.invoice.data.supabase.toRequestMap
import com.essntl.features.invoice.domain.model.InvoiceModel
import com.essntl.features.invoice.domain.repository.InvoiceRepository
import org.koin.core.annotation.Single

@Single(binds = [InvoiceRepository::class])
internal class InvoiceRepositoryImpl(
    private val supabase: InvoiceSupabaseDataSource,
) : Repository(), InvoiceRepository {

    override suspend fun insert(invoiceModel: InvoiceModel): Result<InvoiceModel> =
        runCatching {
            supabase
                .insert(invoiceModel.toRequestMap())
                .toModel()
        }

    override suspend fun update(invoiceModel: InvoiceModel): Result<InvoiceModel> =
        runCatching {
            supabase
                .update(id = invoiceModel.id, invoiceModel.toRequestMap())
                .toModel()
        }

    override suspend fun getById(id: String): Result<InvoiceModel> =
        runCatching {
            supabase
                .getById(id)
                .toModel()
        }

    override suspend fun getByProposalId(proposalId: String): Result<List<InvoiceModel>> =
        runCatching {
            supabase
                .getAll {
                    filter {
                        eq("proposal_id", proposalId)
                    }
                }.map {
                    it.toModel()
                }
        }

    override suspend fun getByItineraryId(itineraryId: String): Result<List<InvoiceModel>> =
        runCatching {
            supabase
                .getAll {
                    filter {
                        eq("itinerary_id", itineraryId)
                    }
                }.map {
                    it.toModel()
                }
        }

    override suspend fun getByIds(ids: List<String>): Result<List<InvoiceModel>> =
        runCatching {
            supabase
                .getByIds(ids)
                .map { it.toModel() }
        }

    override suspend fun delete(id: String): Result<Unit> =
        runCatching {
            supabase
                .delete(id)
        }

}
